import ActionTypes, { TCallToActionState, TDataCallToAction } from './types';
import { Actions, TDefRequest } from '../Action';
import { action } from 'typesafe-actions';

export const CallToActions = {
  setCallToAction: (payload: TCallToActionState['data']) => action(ActionTypes.SET_CALL_TO_ACTION, payload),
};

const GetCallToAction = new Actions('GET_CALL_TO_ACTION', ActionTypes);

export interface TypeGetCallToActioR extends TDefRequest {
  data: TDataCallToAction;
}

export const GetCallAction = {
  request: (payload: TypeGetCallToActioR) => GetCallToAction.request(payload),
  success: (payload: TCallToActionState['data']) => GetCallToAction.success(payload || {}),
  error: (message: string) => GetCallToAction.error(message),
};

const ClickCallToAction = new Actions('CLICK_CALL_TO_ACTION', ActionTypes);

export interface TypeClickCallToActionR extends TDefRequest {
  data: TDataCallToAction;
}
export const ClickCallAction = {
  request: (payload: TypeClickCallToActionR) => ClickCallToAction.request(payload),
  success: (payload: TCallToActionState['data']) => ClickCallToAction.success(payload || {}),
  error: (message: string) => ClickCallToAction.error(message),
};
